import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Renders the standalone Vite-built marketing landing page (served as static
 * files from /public/landing) inside a full-viewport iframe.
 *
 * The landing page's "Explore Learning" CTA is built to point at the sentinel
 * URL https://landing-breakout.local/home. We intercept clicks on it here and
 * break out of the iframe to the old homepage at /home within this app.
 */
const BREAKOUT_HREF = "https://landing-breakout.local/home";

export default function LandingPage() {
  const iframeRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const attach = () => {
      let doc;
      try {
        doc = iframe.contentDocument || iframe.contentWindow?.document;
      } catch (e) {
        return; // cross-origin – nothing we can do
      }
      if (!doc) return;

      const onClick = (e) => {
        const anchor = e.target.closest && e.target.closest("a");
        if (!anchor) return;
        const href = anchor.getAttribute("href") || "";
        if (href === BREAKOUT_HREF || href.startsWith("https://landing-breakout.local")) {
          e.preventDefault();
          e.stopImmediatePropagation();
          navigate("/home");
        }
      };

      doc.addEventListener("click", onClick, true);
      iframe._detach = () => doc.removeEventListener("click", onClick, true);
    };

    iframe.addEventListener("load", attach);
    // in case it is already loaded
    attach();

    return () => {
      iframe.removeEventListener("load", attach);
      if (iframe._detach) iframe._detach();
    };
  }, [navigate]);

  return (
    <iframe
      ref={iframeRef}
      title="Upgrade Skills"
      src="/landing/index.html"
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        border: "none",
      }}
    />
  );
}
